export type EngageLanguage = 'am' | 'ar' | 'bn' | 'de' | 'en' | 'es' | 'et' | 'fil' | 'fr' | 'hi' | 'id' | 'ja' | 'ko' | 'pt' | 'ru' | 'sw' | 'vi' | 'zh';

export type EngageString = 'close' | 'done' | 'next' | 'open' | 'poweredBy' | 'required' | 'send' | 'step' | 'tasks' | 'thanks';

export const ENGAGE_STRINGS: Record<EngageLanguage, Record<EngageString, string>> = {
  am: {
    close: 'ዝጋ',
    done: 'ተጠናቋል',
    next: 'ቀጣይ',
    open: 'ክፈት',
    poweredBy: 'በ Prodantix የቀረበ',
    required: 'ይህ ያስፈልጋል።',
    send: 'ላክ',
    step: '{n} ከ {total}',
    tasks: 'ተግባራት',
    thanks: 'እናመሰግናለን።',
  },
  ar: {
    close: 'إغلاق',
    done: 'تم',
    next: 'التالي',
    open: 'افتح',
    poweredBy: 'مدعوم من Prodantix',
    required: 'هذا مطلوب.',
    send: 'إرسال',
    step: '{n} من {total}',
    tasks: 'المهام',
    thanks: 'شكرًا لك.',
  },
  bn: {
    close: 'বন্ধ করুন',
    done: 'সম্পন্ন',
    next: 'পরবর্তী',
    open: 'খুলুন',
    poweredBy: 'Prodantix দ্বারা চালিত',
    required: 'এটি প্রয়োজন।',
    send: 'পাঠান',
    step: '{total}টির মধ্যে {n}',
    tasks: 'কাজ',
    thanks: 'ধন্যবাদ।',
  },
  de: {
    close: 'Schließen',
    done: 'Fertig',
    next: 'Weiter',
    open: 'Öffnen',
    poweredBy: 'Bereitgestellt von Prodantix',
    required: 'Bitte beantworten.',
    send: 'Senden',
    step: '{n} von {total}',
    tasks: 'Aufgaben',
    thanks: 'Danke!',
  },
  en: {
    close: 'Close',
    done: 'Done',
    next: 'Next',
    open: 'Open',
    poweredBy: 'Powered by Prodantix',
    required: 'This one needs an answer.',
    send: 'Send',
    step: '{n} of {total}',
    tasks: 'Tasks',
    thanks: 'Thank you.',
  },
  es: {
    close: 'Cerrar',
    done: 'Listo',
    next: 'Siguiente',
    open: 'Abrir',
    poweredBy: 'Con la tecnología de Prodantix',
    required: 'Esta necesita una respuesta.',
    send: 'Enviar',
    step: '{n} de {total}',
    tasks: 'Tareas',
    thanks: 'Gracias.',
  },
  et: {
    close: 'Sulge',
    done: 'Valmis',
    next: 'Edasi',
    open: 'Ava',
    poweredBy: 'Toetab Prodantix',
    required: 'See vajab vastust.',
    send: 'Saada',
    step: '{n} / {total}',
    tasks: 'Ülesanded',
    thanks: 'Aitäh.',
  },
  fil: {
    close: 'Isara',
    done: 'Tapos',
    next: 'Susunod',
    open: 'Buksan',
    poweredBy: 'Pinapagana ng Prodantix',
    required: 'Kailangan itong sagutin.',
    send: 'Ipadala',
    step: '{n} sa {total}',
    tasks: 'Mga gawain',
    thanks: 'Salamat.',
  },
  fr: {
    close: 'Fermer',
    done: 'Terminé',
    next: 'Suivant',
    open: 'Ouvrir',
    poweredBy: 'Propulsé par Prodantix',
    required: 'Cette question demande une réponse.',
    send: 'Envoyer',
    step: '{n} sur {total}',
    tasks: 'Tâches',
    thanks: 'Merci.',
  },
  hi: {
    close: 'बंद करें',
    done: 'पूरा',
    next: 'अगला',
    open: 'खोलें',
    poweredBy: 'Prodantix द्वारा संचालित',
    required: 'इसका जवाब चाहिए।',
    send: 'भेजें',
    step: '{total} में से {n}',
    tasks: 'काम',
    thanks: 'धन्यवाद।',
  },
  id: {
    close: 'Tutup',
    done: 'Selesai',
    next: 'Berikutnya',
    open: 'Buka',
    poweredBy: 'Didukung oleh Prodantix',
    required: 'Pertanyaan ini perlu dijawab.',
    send: 'Kirim',
    step: '{n} dari {total}',
    tasks: 'Tugas',
    thanks: 'Terima kasih.',
  },
  ja: {
    close: '閉じる',
    done: '完了',
    next: '次へ',
    open: '開く',
    poweredBy: 'Powered by Prodantix',
    required: 'この質問には回答が必要です。',
    send: '送信',
    step: '{n} / {total}',
    tasks: 'タスク',
    thanks: 'ありがとうございました。',
  },
  ko: {
    close: '닫기',
    done: '완료',
    next: '다음',
    open: '열기',
    poweredBy: 'Prodantix 제공',
    required: '이 질문에 답해 주세요.',
    send: '보내기',
    step: '{n} / {total}',
    tasks: '작업',
    thanks: '감사합니다.',
  },
  pt: {
    close: 'Fechar',
    done: 'Concluir',
    next: 'Avançar',
    open: 'Abrir',
    poweredBy: 'Com tecnologia Prodantix',
    required: 'Esta precisa de uma resposta.',
    send: 'Enviar',
    step: '{n} de {total}',
    tasks: 'Tarefas',
    thanks: 'Obrigado.',
  },
  ru: {
    close: 'Закрыть',
    done: 'Готово',
    next: 'Далее',
    open: 'Открыть',
    poweredBy: 'Работает на Prodantix',
    required: 'Здесь нужен ответ.',
    send: 'Отправить',
    step: '{n} из {total}',
    tasks: 'Задачи',
    thanks: 'Спасибо.',
  },
  sw: {
    close: 'Funga',
    done: 'Imekamilika',
    next: 'Endelea',
    open: 'Fungua',
    poweredBy: 'Inaendeshwa na Prodantix',
    required: 'Hili linahitaji jibu.',
    send: 'Tuma',
    step: '{n} kati ya {total}',
    tasks: 'Kazi',
    thanks: 'Asante.',
  },
  vi: {
    close: 'Đóng',
    done: 'Xong',
    next: 'Tiếp',
    open: 'Mở',
    poweredBy: 'Cung cấp bởi Prodantix',
    required: 'Câu này cần được trả lời.',
    send: 'Gửi',
    step: '{n} trên {total}',
    tasks: 'Việc',
    thanks: 'Cảm ơn bạn.',
  },
  zh: {
    close: '关闭',
    done: '完成',
    next: '下一步',
    open: '打开',
    poweredBy: '由 Prodantix 提供支持',
    required: '此题需要回答。',
    send: '发送',
    step: '{n} / {total}',
    tasks: '任务',
    thanks: '谢谢。',
  },
};

const LANGUAGES: readonly EngageLanguage[] = ['am', 'ar', 'bn', 'de', 'en', 'es', 'et', 'fil', 'fr', 'hi', 'id', 'ja', 'ko', 'pt', 'ru', 'sw', 'vi', 'zh'];

export const engageLanguage = (tag: string | null | undefined): EngageLanguage => {
  const base = (tag ?? '').toLowerCase().split('-')[0] ?? '';
  return LANGUAGES.find(language => language === base) ?? 'en';
};
